import { z } from "zod";
import { ZodStringNullable } from "../zod-types/zod-string-nullable";

/** The invoice a delivery note is linked to by hand, or null to take a wrong link back. */
export const incomingInvoiceDeliveryNoteLinkSchema = z.object({
	incomingInvoiceId: ZodStringNullable,
});

export type IncomingInvoiceDeliveryNoteLinkSchema = z.infer<
	typeof incomingInvoiceDeliveryNoteLinkSchema
>;
